import React from "react";
import {Datagrid, List, TextField} from "react-admin";

const PageList = (props) => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="abstract_title" label="Titre"/>
            <TextField source="abstract_content" label="Résumé"/>
        </Datagrid>
    </List>
);

export default PageList;
